export default __webpack_public_path__ + "static/media/LEARNDESIGN.f5793066.svg";